import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const MahasiswaTable = ()=> {
    let history = useHistory()
    const url = "https://backendexample.sanbercloud.com"
    const [mahasiswa, setMahasiswa] = useState([]);
    const [fetchTrigger, setFetchTrigger] = useState(true)


    useEffect(() => {
        const fetchData = async () => {
            let result = await axios.get(`${url}/api/student-scores`)
            let data = result.data
            setMahasiswa(data.map(x=>{return {id: x.id, name: x.name, course: x.course, score: x.score,
            index: x.score}}))
            setFetchTrigger(false)
        }
        if (fetchTrigger){
            fetchData()
        }
    }, [fetchTrigger])

    const addNewDataMhs = () => {
        history.push("/nilai-mahasiswa/create")
    }


    const handleEdit = async (event) =>{
        let idMhs = Number(event.target.value)
        let idx = mahasiswa[idMhs].id

        history.push(`/nilai-mahasiswa/${idx}/edit`)
      }
    
      const handleDelete = (event) =>{
        let idPeserta = parseInt(event.target.value)
        let id = mahasiswa[idPeserta].id
        axios.delete(`${url}/api/student-scores/${id}`)
        .then((res) => {
          setMahasiswa(mahasiswa.filter((x)=> x.id !== id))
        }).catch((err)=>{
            console.log(err)
        })
      }
    
    return(
    <>
        <div className='App'>
            <h1 className='App'>Daftar Nilai Mahasiswa</h1>
            <table className='custom-table'>
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Nama</th>
                        <th>Mata Kuliah</th>
                        <th>Nilai</th>
                        <th>Index Nilai</th>
                        <th>Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    {mahasiswa.map ((item, index) =>{
                        function indexNilai(n){
                            if (n >= 80){
                                var index = "A";
                                return index;
                            } else if (n >= 70 && n < 80){
                                index = "B";
                                return index;
                            } else if (n >= 60 && n < 70){
                                index = "C";
                                return index;
                            } else if (n >= 50 && n < 60){
                                index = "D";
                                return index;
                            } else {
                                index = "E";
                                return index;
                            }

                        } 
                        return(
                            <tr key={index}>
                                <td>{index+1}</td>
                                <td>{item.name}</td>
                                <td>{item.course}</td>
                                <td>{item.score}</td>
                                <td>{indexNilai(item.score)}</td>
                                <td>
                                <button className="button-edit mr-10" onClick={handleEdit} value={index}>Edit</button>
                                <button className="button-delete" onClick={handleDelete} value={index}>Delete</button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <button className='button-add' onClick={addNewDataMhs}> Tambah Data Mahasiswa</button>
        </div>
            
            
    </>
    )
}

export default MahasiswaTable;